import * as React from 'react';
import { createSvgIcon } from "..";

export const Circle = createSvgIcon(
  <><rect width="14" height="14" x="1" y="1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" rx="7" /></>,
  'small',
);
